import { render, staticRenderFns } from "./MenuMargins.vue?vue&type=template&id=b15a1e82&scoped=true&"
import script from "./MenuMargins.vue?vue&type=script&lang=js&"
export * from "./MenuMargins.vue?vue&type=script&lang=js&"
import style0 from "./MenuMargins.vue?vue&type=style&index=0&id=b15a1e82&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15a1e82",
  null
  
)

export default component.exports